import { render, staticRenderFns } from "./scatter-chart-card.vue?vue&type=template&id=40a54d53&"
import script from "./scatter-chart-card.vue?vue&type=script&lang=js&"
export * from "./scatter-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "scatter-chart-card.vue"
export default component.exports